import React from 'react';
import { OrderHeaderInfo } from './order-header-info';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { ILxsOrderData } from '../lxs-create-order.data';
import Disclaimer from '../components/disclaimer';
import { ICoreContext } from '@msdyn365-commerce/core';

interface IOverviewProps {
    orderData: ILxsOrderData;
    resources: ILxsCreateOrderResources;
    step: number;
    context: ICoreContext;
    productsHaveEndcustomers: boolean;
    placeOrder: () => void;
    pushHistoryState: (currentStep: number) => void;
}

export default function overview({
    orderData,
    resources,
    step,
    context,
    productsHaveEndcustomers,
    placeOrder,
    pushHistoryState
}: IOverviewProps) {
    return (
        <>
            <OrderHeaderInfo
                context={context}
                orderData={orderData}
                resources={resources}
                step={step}
                pushHistoryState={pushHistoryState}
                productsHaveEndcustomers={productsHaveEndcustomers}
            ></OrderHeaderInfo>
            <Disclaimer resources={resources} placeOrder={placeOrder} />
        </>
    );
}
